import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import AuthLayout from "../components/AuthLayout";

export default function VenueForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/venue/forgot", { email, origin: window.location.origin });
      setSent(true);
    } catch {
      setSent(true); // generic response to avoid leaking which emails exist
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Reset door access" subtitle="Venue door staff — enter your login email and we'll send a secure link to set a new password.">
      {sent ? (
        <div data-testid="venue-forgot-sent" className="rounded-xl bg-[#eefafa] border border-[#c9efef] p-5 text-[#16243b]">
          <p className="font-medium">Check your inbox</p>
          <p className="text-sm text-[#5a6b80] mt-1">If a venue account exists for <strong>{email}</strong>, we've sent a password reset link. It expires in 1 hour.</p>
          <Link to="/login" className="text-[#1fb0b0] font-medium hover:underline text-sm mt-4 inline-block" data-testid="venue-back-to-login">Back to sign in</Link>
        </div>
      ) : (
        <>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[#16243b] mb-1.5">Venue login email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="venue-forgot-email"
                className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-[#2ec9c9] focus:ring-2 focus:ring-[#2ec9c9]/20 transition" placeholder="door@venue.com" />
            </div>
            <button disabled={loading} data-testid="venue-forgot-submit" className="gp-btn-teal w-full rounded-xl py-3 font-medium disabled:opacity-60">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
          <p className="text-sm text-[#5a6b80] mt-6 text-center">
            Remembered it? <Link to="/login" className="text-[#1fb0b0] font-medium hover:underline">Back to sign in</Link>
          </p>
        </>
      )}
    </AuthLayout>
  );
}
